import 'rc-slider/assets/index.css';
import React, { Component } from 'react';
import Slider from 'rc-slider';
import NumberField from "./NumberInput";


const Handle = Slider.Handle;

const handle = (props) => {
    const { value, dragging, index, ...restProps } = props;
    return (
        <Handle value={value} {...restProps}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 102">
                <g style={{ opacity: 0.8 }}>
                    <polygon style={{ fill: '#000000' }} points="58.841 0 0 102 117.682 102 58.841 0"/>
                </g>
                <g style={{ opacity: 0.8 }}>
                    <polygon style={{ fill: '#000000' }} points="58.841 102 58.841 0 128 0 58.841 102"/>
                </g>
            </svg>
        </Handle>
    );
};

class CalcControl extends Component {
    constructor(props) {
        super(props);

        this.onEnterPress = this.onEnterPress.bind(this);
    }

    onEnterPress(e) {
        if(this.props.preventEnter && (e.key === 'Enter' || e.target.keyCode === 13))
            e.preventDefault();
    }

    render() {
        return (
            <div className={['credit-calc-control', this.props.className].filter(className => !!className).join(' ')}>
                <label className="credit-calc-control-label">
                    {this.props.label}
                    {this.props.subLabel && <span className="credit-calc-control-sub-label">{this.props.subLabel}</span>}
                </label>

                <div className="credit-calc-control-inner">
                    {typeof this.props.min !== 'undefined' && typeof this.props.max !== 'undefined' && typeof this.props.step !== 'undefined' &&
                        <Slider
                            className="credit-calc-control-slider"
                            handle={handle}
                            min={this.props.min}
                            max={this.props.max}
                            step={this.props.step}
                            value={this.props.value}
                            onChange={this.props.onSliderChange.bind(this, this.props.name)}
                            onAfterChange={this.props.onAfterChange}
                        />}
                    
                    <NumberField
                        className="credit-calc-control-input"
                        value={this.props.value}
                        name={this.props.name}
                        change={this.props.onInputChange}
                        min={this.props.min}
                        max={this.props.max}
                        currency={this.props.currency | false}
                        decimals={this.props.decimals | 0}
                        readOnly={this.props.readOnly}
                        onKeyPress={this.onEnterPress}
                        tabIndex={this.props.tabIndex}
                    />
                </div>
            </div>
        );
    }
}

export default CalcControl;